import { render, staticRenderFns } from "./modalCameraFlow.pug?vue&type=template&id=78d09123&lang=pug&external"
import script from "./modalCameraFlow.js?vue&type=script&lang=js&external"
export * from "./modalCameraFlow.js?vue&type=script&lang=js&external"
import style0 from "./modalCameraFlow.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78d09123')) {
      api.createRecord('78d09123', component.options)
    } else {
      api.reload('78d09123', component.options)
    }
    module.hot.accept("./modalCameraFlow.pug?vue&type=template&id=78d09123&lang=pug&external", function () {
      api.rerender('78d09123', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modalCameraFlow/index.vue"
export default component.exports